import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.less';

const CustomSlider = ({
  max = 100,
  min = 0,
  defaultValue = 0,
  onChange = () => {},
  format,
  step = 1,
  unit = '',
  id,
  // 是否展示最大最小值
  showLabel = false,
  // 是否展示标签
  showTag = true,
  className = '',
  marks,
}) => {
  const [tagPosition, setTagPosition] = useState(0);

  const handleSliderChange = e => {
    const current = e.target.value;
    onChange(current, id);
  };

  const computePosition = useCallback(value => ((value - min) / (max - min)) * 100, [max, min]);

  const formatValue = useCallback(value => (format ? `${format(value)}` : `${value}${unit}`), [
    format,
    unit,
  ]);

  const renderDots = useCallback(() => {
    if (!marks || typeof marks !== 'object' || Object.keys(marks)?.length <= 0) return null;
    return (
      <ul className={styles['slider-dots']}>
        {Object.keys(marks).map(key => {
          const dotLeft = computePosition(key);
          return (
            <li
              className={`${styles['slider-dot']} ${defaultValue > key ? styles['active'] : ''}`}
              key={key}
              style={{ left: `${dotLeft}%`, transform: `translateX(-${dotLeft}%)` }}
            >
              {marks[key]}
            </li>
          );
        })}
      </ul>
    );
  }, [marks, computePosition, defaultValue]);

  useEffect(() => {
    const position = computePosition(defaultValue);
    setTagPosition(position);
  }, [defaultValue, computePosition]);

  return (
    <div
      className={`${styles['xp-rangebox']} ${className} ${marks ? styles['with-dots'] : ''} ${
        showTag ? styles['showTag'] : ''
      }`}
    >
      {renderDots()}
      <input
        style={{ backgroundSize: `${tagPosition}%` }}
        className={styles['xp-irange']}
        id="iRange"
        type="range"
        min={min}
        max={max}
        value={defaultValue}
        step={step}
        onChange={handleSliderChange}
      />
      {showLabel && (
        <>
          <span className={`${styles['xp-bar-num']} ${styles['xp-bar-num-left']}`}>
            {min}
            {unit}
          </span>
          <span className={`${styles['xp-bar-num']} ${styles['xp-bar-num-right']}`}>
            {max}
            {unit}
          </span>
        </>
      )}
      {showTag && (
        <em
          id="xpRangeNum"
          style={{
            left: `${tagPosition}%`,
            transform: `translateX(-${tagPosition}%)`,
          }}
        >
          {formatValue(defaultValue)}
        </em>
      )}
    </div>
  );
};
export default CustomSlider;
